
















































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Util from "@/lib/util";
class CreateDateType {
  startDate: Date | string = "";
  endDate: Date | string = "";
}
@Component({
  components: {},
})
export default class CreateCouponCourt extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({ type: Number, default: 0 }) supplierOfferId: number;

  createDate: CreateDateType = new CreateDateType();
  id: number = 0;
  title: string = "添加日期";
  save() {
    (this.$refs.createDateForm as any).validate(async (valid: boolean) => {
      if (valid) {
        let data = {
          startDate: this.createDate.startDate,
          endDate: this.createDate.endDate,
          supplierOfferId: this.$props.supplierOfferId,
        };
        //此时是编辑
        if (this.id > 0) {
          data["id"] = this.id;
        }
        let type =
          this.id > 0 ? "offerDateSlot/update" : "offerDateSlot/create";
        await this.$store.dispatch({
          type: type,
          data,
        });
        (this.$refs.createDateForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      } else {
        this.$Message.error("表单校验不通过");
      }
    });
  }
  cancel() {
    (this.$refs.createDateForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.id = 0;
      this.title = "添加日期";
      this.$emit("input", value);
    } else {
      let data = Util.extend(
        true,
        {},
        this.$store.state.offerDateSlot.editOfferDateSlot
      );
      if (data && data.id > 0) {
        this.id = data.id;
        this.createDate.startDate = data.startDate;
        this.createDate.endDate = data.endDate;
        this.title = "编辑日期";
      }
    }
  }
  checkStartDate(rule: any, value: any, callback: any) {
    if (value === undefined || value === null || !value.trim()) {
      callback(new Error("请选择开始日期"));
    } else {
      callback();
    }
  }
  checkEndDate(rule: any, value: any, callback: any) {
    if (value === undefined || value === null || !value.trim()) {
      callback(new Error("请选择结束日期"));
    } else if (
      this.createDate.startDate &&
      new Date(value) < new Date(this.createDate.startDate)
    ) {
      callback(new Error("结束日期不能早于开始日期"));
    } else {
      callback();
    }
  }
  createDateRule = {
    startDate: [
      {
        required: true,
        validator: this.checkStartDate,
        trigger: "change",
      },
    ],
    endDate: [
      {
        required: true,
        validator: this.checkEndDate,
        trigger: "change",
      },
    ],
  };
}
